import React from 'react';
import { FaDownload, FaTimes, FaCalendarAlt, FaUser, FaFolderOpen, FaInfoCircle, FaTag } from 'react-icons/fa';
import { formatFileSize } from '../../utils/formatters';
import '../../styles/Files.css';

const FileDetails = ({ file, onClose, onDownload }) => {
  if (!file) return null;
  
  const handleDownload = async () => {
    if (onDownload) {
      onDownload(file.originalId, file.name);
    }
  };
  
  // In a real implementation, this would show a preview of the 3D model
  // For now, we'll just show a placeholder
  const getThumbnailUrl = (file) => {
    // This is a dummy implementation
    if (file.thumbnailUrl) {
      return file.thumbnailUrl;
    }
    
    return '/model-placeholder.png';
  };
  
  // Get mock metadata for the file
  const getMetadata = (file) => {
    // This is a dummy implementation
    return {
      description: "This is a 3D model file from MyMiniFactory",
      tags: ["miniature", "tabletop", "fantasy"],
      license: "Standard MyMiniFactory License",
      dimensions: {
        width: "85mm",
        height: "120mm",
        depth: "35mm"
      },
      polygons: Math.floor(Math.random() * 500000) + 100000,
      category: file.name.includes("terrain") ? "Terrain" : 
                file.name.includes("character") ? "Character" :
                file.name.includes("prop") ? "Prop" : "Miscellaneous"
    };
  };
  
  const metadata = getMetadata(file);
  
  return (
    <div className="file-details">
      <div className="file-details-header">
        <h3>{file.name}</h3>
        <button className="close-details" onClick={onClose}>
          <FaTimes />
        </button>
      </div>
      
      <div className="file-details-content">
        <div className="file-preview">
          <img 
            src={getThumbnailUrl(file)} 
            alt={file.name} 
            className="file-thumbnail"
          />
          
          <button 
            className="download-button detail-download"
            onClick={handleDownload}
          >
            <FaDownload /> Download File
          </button>
        </div>
        
        <div className="file-info">
          <div className="file-info-section">
            <h4>File Information</h4>
            
            <div className="info-row">
              <div className="info-label">
                <FaUser /> Creator
              </div>
              <div className="info-value">
                {file.creatorName || "Unknown"}
              </div>
            </div>
            
            <div className="info-row">
              <div className="info-label">
                <FaCalendarAlt /> Updated
              </div>
              <div className="info-value">
                {new Date(file.updatedAt).toLocaleDateString()}
              </div>
            </div>
            
            <div className="info-row">
              <div className="info-label">
                <FaInfoCircle /> Size
              </div>
              <div className="info-value">
                {formatFileSize(file.fileSize)}
              </div>
            </div>
            
            <div className="info-row">
              <div className="info-label">
                <FaFolderOpen /> Category
              </div>
              <div className="info-value">
                {metadata.category}
              </div>
            </div>
          </div>
          
          <div className="file-info-section">
            <h4>Metadata</h4>
            
            <div className="info-row">
              <div className="info-label">Description</div>
              <div className="info-value description">
                {metadata.description}
              </div>
            </div>
            
            <div className="info-row">
              <div className="info-label">
                <FaTag /> Tags
              </div>
              <div className="info-value tags">
                {metadata.tags.map((tag, index) => (
                  <span key={index} className="tag">{tag}</span>
                ))}
              </div>
            </div>
            
            <div className="info-row">
              <div className="info-label">Dimensions</div>
              <div className="info-value">
                {metadata.dimensions.width} × {metadata.dimensions.height} × {metadata.dimensions.depth}
              </div>
            </div>
            
            <div className="info-row">
              <div className="info-label">Polygons</div>
              <div className="info-value">
                {metadata.polygons.toLocaleString()}
              </div>
            </div>
            
            <div className="info-row">
              <div className="info-label">License</div>
              <div className="info-value">
                {metadata.license}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileDetails;